import React, {useEffect, useState, useRef, Fragment} from 'react';
import ArrowOutwardOutlinedIcon from '@mui/icons-material/ArrowOutwardOutlined';
import {Line} from 'react-chartjs-2';
import {
    Grid,
    Typography,
    Paper,
    Button,
    Dialog,
    DialogContent,
    Link,
    Box,
    useMediaQuery,
    useTheme
} from '@mui/material';
import 'chart.js/auto';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import {recordScore} from '../../interfaces/recordScore'
import {ScriptableContext} from 'chart.js/auto';

const CourseGrid = ({records}: { records: recordScore[] }) => {

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const isUnmounted = useRef(false);
    const [categoryTotals, setCategoryTotals] = useState<any>({});
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        return () => {
            isUnmounted.current = true;
        };
    }, []);


    const handleDialogOpen = (category: any) => {
        setSelectedCategory(category);
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setSelectedCategory(null);
        setOpenDialog(false);
    };

    // useEffect(() => {
    //   const categoryNames: Array<keyof recordScore> = [
    //     'chipping_bunkers_1',
    //     'chipping_bunkers_2',
    //     'putting',
    //     'mental_game',
    //     'wedge_game_1',
    //     'wedge_game_2',
    //     'driving',
    //     'ball_striking',
    //     'score'
    //   ];

    //   // Clear existing category totals
    //   for (const prop of Object.getOwnPropertyNames(categoryTotals)) {
    //     delete categoryTotals[prop];
    //   }

    //   const updatedCategoryTotals = { ...categoryTotals };
    //   const reversedRecords = [...records].reverse();

    //   reversedRecords.forEach((entry) => {
    //     const recordDate = entry.record_date;
    //     const year = parseInt(recordDate.split('-')[0], 10); // Extract the year from the date and parse as a number
    //     const month = parseInt(recordDate.split('-')[1], 10); // Extract the month from the date and parse as a number

    //     // Iterate through predefined category names
    //     categoryNames.forEach((categoryName) => {
    //       // category value as a number
    //       const categoryValue = entry[categoryName] !== undefined ? parseInt(entry[categoryName] as string, 10) : 0;

    //       // add category if it does not exist
    //       if (!updatedCategoryTotals[categoryName]) {
    //         updatedCategoryTotals[categoryName] = {};
    //       }

    //       // add year if it does not exist
    //       if (!updatedCategoryTotals[categoryName][year]) {
    //         updatedCategoryTotals[categoryName][year] = {};
    //       }

    //       // add month if it does not exist
    //       if (!updatedCategoryTotals[categoryName][year][month]) {
    //         updatedCategoryTotals[categoryName][year][month] = 0;
    //       }

    //       // Add to total
    //       updatedCategoryTotals[categoryName][year][month] += categoryValue;

    //       if (categoryName === 'chipping_bunkers_1') {
    //         const bunkers2Value = entry['chipping_bunkers_2'] !== undefined ? parseInt(entry['chipping_bunkers_2'] as string, 10) : 0;
    //         const ratio = bunkers2Value > 0 ? (categoryValue / bunkers2Value) * 100 : 0;

    //         // add category if it does not exist
    //         if (!updatedCategoryTotals['chipping_bunkers']) {
    //           updatedCategoryTotals['chipping_bunkers'] = {};
    //         }

    //         // add year if it does not exist
    //         if (!updatedCategoryTotals['chipping_bunkers'][year]) {
    //           updatedCategoryTotals['chipping_bunkers'][year] = {};
    //         }

    //         // add month if it does not exist
    //         if (!updatedCategoryTotals['chipping_bunkers'][year][month]) {
    //           updatedCategoryTotals['chipping_bunkers'][year][month] = 0;
    //         }

    //         // Add chipping bunkers ratio to total
    //         updatedCategoryTotals['chipping_bunkers'][year][month] += ratio;
    //       }

    //       if (categoryName === 'wedge_game_1') {
    //         const wedge2Value = entry['wedge_game_2'] !== undefined ? parseInt(entry['wedge_game_2'] as string, 10) : 0;
    //         const ratio = wedge2Value > 0 ? (categoryValue / wedge2Value) : 0;

    //         // add category if it does not exist
    //         if (!updatedCategoryTotals['wedge_game']) {
    //           updatedCategoryTotals['wedge_game'] = {};
    //         }

    //         // add year if it does not exist
    //         if (!updatedCategoryTotals['wedge_game'][year]) {
    //           updatedCategoryTotals['wedge_game'][year] = {};
    //         }

    //         // add month if it does not exist
    //         if (!updatedCategoryTotals['wedge_game'][year][month]) {
    //           updatedCategoryTotals['wedge_game'][year][month] = 0;
    //         }

    //         // Add chipping bunkers ratio to total
    //         updatedCategoryTotals['wedge_game'][year][month] += ratio;
    //       }

    //       if (categoryName === 'score') {
    //         const scoreValue = entry['score'] !== undefined ? entry['score'] : 0;

    //         // add category if it does not exist
    //         if (!updatedCategoryTotals['scoreAvg']) {
    //           updatedCategoryTotals['scoreAvg'] = {};
    //         }

    //         // add year if it does not exist
    //         if (!updatedCategoryTotals['scoreAvg'][year]) {
    //           updatedCategoryTotals['scoreAvg'][year] = {};
    //         }

    //         // add month if it does not exist
    //         if (!updatedCategoryTotals['scoreAvg'][year][month]) {
    //           updatedCategoryTotals['scoreAvg'][year][month] = {
    //             sum: 0,
    //             count: 0,
    //             averages: []
    //           };
    //         }

    //         updatedCategoryTotals['scoreAvg'][year][month].sum += scoreValue;
    //         updatedCategoryTotals['scoreAvg'][year][month].count++;
    //         updatedCategoryTotals['scoreAvg'][year][month].averages.push(scoreValue);
    //       }

    //       if (
    //         updatedCategoryTotals['scoreAvg'] &&
    //         updatedCategoryTotals['scoreAvg'][year] &&
    //         updatedCategoryTotals['scoreAvg'][year][month] &&
    //         updatedCategoryTotals['scoreAvg'][year][month].averages
    //       ) {
    //         const sums = updatedCategoryTotals['scoreAvg'][year][month].sum;
    //         const averages = updatedCategoryTotals['scoreAvg'][year][month].averages;

    //         if (averages && averages.length > 0) {
    //           // const sum = averages.reduce((acc: number, average: number) => acc + average, 0);
    //           const averageScore = sums / averages.length;
    //           updatedCategoryTotals['scoreAvg'][year][month].average = averageScore;
    //         }
    //       }


    //     });
    //   });
    //   const sortedCategoryTotals: Record<string, Record<string, Record<string, number>>> = {};

    //   for (const categoryName in updatedCategoryTotals) {
    //     const sortedYearEntries: [string, Record<string, number>][] = Object.entries(updatedCategoryTotals[categoryName])
    //       .sort(([a], [b]) => parseInt(a, 10) - parseInt(b, 10))
    //       .map(([year, data]) => [year, data as Record<string, number>]);

    //     sortedCategoryTotals[categoryName] = Object.fromEntries(sortedYearEntries);
    //   }

    //   setCategoryTotals(sortedCategoryTotals);
    // //   console.log("totals are  >> ", sortedCategoryTotals);
    //   // eslint-disable-next-line
    // }, [records]);


    useEffect(() => {
        const categoryNames: Array<keyof recordScore> = [
          'chipping_bunkers_1',
          'chipping_bunkers_2',
          'putting',
          'mental_game',
          'wedge_game_1',
          'wedge_game_2',
          'driving',
          'ball_striking',
          'score'
        ];

        // Clear existing category totals
        for (const prop of Object.getOwnPropertyNames(categoryTotals)) {
          delete categoryTotals[prop];
        }

        const updatedCategoryTotals = { ...categoryTotals };
        const reversedRecords = [...records].reverse();

        reversedRecords.forEach((entry) => {
          const recordDate = entry.record_date;
          const year = parseInt(recordDate.split('-')[0], 10);
          const month = parseInt(recordDate.split('-')[1], 10);

          categoryNames.forEach((categoryName) => {
            const categoryValue = entry[categoryName] !== undefined ? parseInt(entry[categoryName] as string, 10) : 0;

            if (!updatedCategoryTotals[categoryName]) {
              updatedCategoryTotals[categoryName] = {};
            }

            if (!updatedCategoryTotals[categoryName][year]) {
              updatedCategoryTotals[categoryName][year] = {};
            }

            if (!updatedCategoryTotals[categoryName][year][month]) {
              updatedCategoryTotals[categoryName][year][month] = {
                sum: 0,
                count: 0,
                averages: [],
                average: 0
              };
            }

            updatedCategoryTotals[categoryName][year][month].sum += categoryValue;
            updatedCategoryTotals[categoryName][year][month].count++;
            updatedCategoryTotals[categoryName][year][month].averages.push(categoryValue);

            // Calculate average
            const sum = updatedCategoryTotals[categoryName][year][month].sum;
            const count = updatedCategoryTotals[categoryName][year][month].count;
            const nonZeroAverages = updatedCategoryTotals[categoryName][year][month].averages.filter((value: number) => value !== 0);
            updatedCategoryTotals[categoryName][year][month].average = sum / nonZeroAverages.length;

            // Additional calculation for 'chipping_bunkers_1'
            if (categoryName === 'chipping_bunkers_1') {
              const bunkers2Value = entry['chipping_bunkers_2'] !== undefined ? parseInt(entry['chipping_bunkers_2'] as string, 10) : 0;
              const ratio = bunkers2Value > 0 ? (categoryValue / bunkers2Value) * 100 : 0;

              if (!updatedCategoryTotals['chipping_bunkers']) {
                updatedCategoryTotals['chipping_bunkers'] = {};
              }

              if (!updatedCategoryTotals['chipping_bunkers'][year]) {
                updatedCategoryTotals['chipping_bunkers'][year] = {};
              }

              if (!updatedCategoryTotals['chipping_bunkers'][year][month]) {
                updatedCategoryTotals['chipping_bunkers'][year][month] = {
                  sum: 0,
                  count: 0,
                  averages: [],
                  average: 0
                };
              }

              updatedCategoryTotals['chipping_bunkers'][year][month].sum += ratio;
              updatedCategoryTotals['chipping_bunkers'][year][month].count++;
              updatedCategoryTotals['chipping_bunkers'][year][month].averages.push(ratio);
              const nonZeroAverages = updatedCategoryTotals['chipping_bunkers'][year][month].averages.filter((value: number) => value !== 0);
              updatedCategoryTotals['chipping_bunkers'][year][month].average = updatedCategoryTotals['chipping_bunkers'][year][month].sum / nonZeroAverages.length;
            }

            if (categoryName === 'wedge_game_1') {
                const wedge2Value = entry['wedge_game_2'] !== undefined ? parseInt(entry['wedge_game_2'] as string, 10) : 0;
                const ratio = wedge2Value > 0 ? (categoryValue / wedge2Value) : 0;
                console.log("wedge game value is >> ", entry['score']);

                // add category if it does not exist
                if (!updatedCategoryTotals['wedge_game']) {
                  updatedCategoryTotals['wedge_game'] = {};
                }

                // add year if it does not exist
                if (!updatedCategoryTotals['wedge_game'][year]) {
                  updatedCategoryTotals['wedge_game'][year] = {};
                }

                // add month if it does not exist
                if (!updatedCategoryTotals['wedge_game'][year][month]) {
                  updatedCategoryTotals['wedge_game'][year][month] = {
                    sum: 0,
                    count: 0,
                    averages: [],
                    average: 0
                  };
                }

              updatedCategoryTotals['wedge_game'][year][month].sum += ratio;
              updatedCategoryTotals['wedge_game'][year][month].count++;
              updatedCategoryTotals['wedge_game'][year][month].averages.push(ratio);
              const nonZeroAverages = updatedCategoryTotals['wedge_game'][year][month].averages.filter((value: number) => value !== 0);
              updatedCategoryTotals['wedge_game'][year][month].average = updatedCategoryTotals['wedge_game'][year][month].sum / nonZeroAverages.length;
              }

              if (categoryName === 'score') {
                        const scoreValue = entry['score'] !== undefined ? entry['score'] : 0;

                        // add category if it does not exist
                        if (!updatedCategoryTotals['scoreAvg']) {
                          updatedCategoryTotals['scoreAvg'] = {};
                        }

                        // add year if it does not exist
                        if (!updatedCategoryTotals['scoreAvg'][year]) {
                          updatedCategoryTotals['scoreAvg'][year] = {};
                        }

                        // add month if it does not exist
                        if (!updatedCategoryTotals['scoreAvg'][year][month]) {
                          updatedCategoryTotals['scoreAvg'][year][month] = {
                            sum: 0,
                            count: 0,
                            averages: []
                          };
                        }

                        updatedCategoryTotals['scoreAvg'][year][month].sum += scoreValue;
                        updatedCategoryTotals['scoreAvg'][year][month].count++;
                        updatedCategoryTotals['scoreAvg'][year][month].averages.push(scoreValue);
                      }

                      if (
                        updatedCategoryTotals['scoreAvg'] &&
                        updatedCategoryTotals['scoreAvg'][year] &&
                        updatedCategoryTotals['scoreAvg'][year][month] &&
                        updatedCategoryTotals['scoreAvg'][year][month].averages
                      ) {
                        const sums = updatedCategoryTotals['scoreAvg'][year][month].sum;
                        const averages = updatedCategoryTotals['scoreAvg'][year][month].averages;

                        const nonZeroAverages = averages.filter((value: number) => value !== 0);
                        console.log("non zeaero avg >> ", nonZeroAverages);

                        if (nonZeroAverages.length > 0) {
                            const averageScore = sums / nonZeroAverages.length;
                            updatedCategoryTotals['scoreAvg'][year][month].average = averageScore
                        }

                        // if (averages && averages.length > 0) {
                        //   // const sum = averages.reduce((acc: number, average: number) => acc + average, 0);
                        //   const averageScore = sums / averages.length;
                        //   updatedCategoryTotals['scoreAvg'][year][month].average = averageScore;
                        // }
                      }
          });
        });

        const sortedCategoryTotals: Record<string, Record<string, Record<string, number>>> = {};

        for (const categoryName in updatedCategoryTotals) {
          const sortedYearEntries: [string, Record<string, number>][] = Object.entries(
            updatedCategoryTotals[categoryName]
          )
            .sort(([a], [b]) => parseInt(a, 10) - parseInt(b, 10))
            .map(([year, data]) => [year, data as Record<string, number>]);

          sortedCategoryTotals[categoryName] = Object.fromEntries(sortedYearEntries);
        }

        setCategoryTotals(sortedCategoryTotals);
        console.log("totals are >> ", sortedCategoryTotals);
        // eslint-disable-next-line
      }, [records]);
    

    const monthNames: Record<string, string> = {
        "1": "Jan.",
        "2": "Feb.",
        "3": "Mar.",
        "4": "Apr.",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "Aug.",
        "9": "Sep.",
        "10": "Oct.",
        "11": "Nov.",
        "12": "Dec."
    };

    const categoryDisplayNameMap: Record<string, string> = {
        'chipping_bunkers': 'Chipping & Bunkers',
        'putting': 'Putting',
        'mental_game': 'Mental Game',
        'wedge_game': 'Wedge Game',
        'driving': 'Driving',
        'ball_striking': 'Ball Striking',
    };

    const categorySubtitles: Record<string, string> = {
        'chipping_bunkers': 'Up & Down %',
        'putting': 'Putts',
        'mental_game': 'Mental Score',
        'wedge_game': 'Stroke Average from 30-100',
        'driving': 'Fairway Hit',
        'ball_striking': 'Green in Regulation',
    };

    const categoryLinks: Record<string, string> = {
        'chipping_bunkers': "https://members.performancegolf.com/scratch-club/chipping-bunkers/",
        'putting': 'https://members.performancegolf.com/scratch-club/putting/',
        'mental_game': 'https://members.performancegolf.com/scratch-club/mental-game/',
        'wedge_game': 'https://members.performancegolf.com/scratch-club/wedge-game/',
        'driving': 'https://members.performancegolf.com/scratch-club/driving/',
        'ball_striking': 'https://members.performancegolf.com/scratch-club/ball-striking/',
    }

    const checkScAccess = () => {
        if (typeof window !== 'undefined' && window.pgUser?.products) {
            return window.pgUser.products.some((product: string) => product === '1' || product === 'Scratch Club'); // Scratch Club product ID
        }
        return false;
    };

    const renderCourseGraphs = () => {
        const categories = [
            'chipping_bunkers',
            // 'chipping_bunkers_2',
            'putting',
            'mental_game',
            'wedge_game',
            // 'wedge_game_2',
            'driving',
            'ball_striking',
        ];

        const graphsPerRow = 3;
        const rows: JSX.Element[][] = [];

        categories.forEach((category, index) => {
            if (index % graphsPerRow === 0) {
                rows.push([]);
            }

            let year:string = "";
            let month:string[]=[];
            let monthNum:string="";
            let monthName:string="";
            let value:number=0;
            Object.keys(categoryTotals[category] || {}).map((key) => {
              year = key;
              month = Object.keys(categoryTotals['chipping_bunkers']?.[key]);
              monthNum = month[0];
              monthName = monthNames[month[0]];
              value = categoryTotals[category]?.[key][monthNum]
            }) 
            const rowGraph = (
               

                <Grid key={index}
                      item
                      xs={12} // Set full width for mobile view
                      md={6}  // Set 50% width for larger screens
                      lg={4}  // Set 33.33% width for larger screens
                      xl={4}  // Set 25% width for extra-large screens
                      style={{ flex: 1}}>
                    <Typography variant="h6" style={{marginBottom: '10px', lineHeight:0, fontFamily: isMobile ? "'Lato', sans-serif" : "'Repro', sans-serif", fontWeight: isMobile ? 600 : 400, fontSize: "16px"}}>
                        {categoryDisplayNameMap[category] || category}
                    </Typography>
                    {categorySubtitles[category] && (
                        <Typography variant="subtitle1" style={{marginBottom: '10px', 
                        fontFamily: isMobile ? "'Lato', sans-serif" : "'Repro', sans-serif", 
                        fontWeight: 400, 
                        fontSize: "12px",
                        color: isMobile ? '#7B726C' : '#182026'}}>
                            {categorySubtitles[category]}
                        </Typography>
                    )}
                    <Paper variant="outlined" style={{
                        position: 'relative',
                        overflow: 'visible',
                        border: '1px solid #ddd', // Gray border
                        borderRadius: '8px',
                        paddingTop: '35px'
                    }}>
                        <Button onClick={() => {
                            handleDialogOpen(category);
                        }}
                                style={{
                                    position: 'absolute',
                                    top: 4,
                                    right: 4, 
                                    border: '1px solid #ccc', // Light gray border
                                    borderRadius: '4px',
                                    color: 'black',
                                    fontSize: '2px',
                                    width: '24px',
                                    height: '24px',
                                    minWidth:'24px',
                                    padding:'0px'
                                }}
                        >
                            <OpenInFullIcon fontSize="small"/>
                        </Button>
                        <Line
                            data={{
                              labels: Object.keys(categoryTotals[category] || {}).flatMap((year) => {
                                return Object.keys(categoryTotals[category]?.[year] || {}).map((month) => {
                                  const monthName = monthNames[parseInt(month, 10)];
                                  return monthName ? `${monthName} ${year}` : `${month} ${year}`;
                                });
                              }),
                                datasets: [
                                    {
                                // shows sums
                                        // data: Object.keys(categoryTotals[category] || {}).flatMap((year) => {
                                        //     return Object.keys(categoryTotals[category]?.[year] || {}).map((month) => {
                                        //       return categoryTotals[category]?.[year]?.[month]?.sum || 0; // Use sum instead of average
                                        //     });
                                        // }),

                                //shows averages
                                        data: Object.keys(categoryTotals[category] || {}).flatMap((year) => {
                                            return Object.keys(categoryTotals[category]?.[year] || {}).map((month) => {
                                              return categoryTotals[category]?.[year]?.[month]?.average || 0;
                                            });
                                          }),
                                        pointRadius: 5,
                                        pointBackgroundColor: '#DB2C00',
                                        borderWidth: 1,
                                        borderColor: '#DB2C00',
                                        backgroundColor: (context: ScriptableContext<"line">) => {
                                            const ctx = context.chart.ctx;
                                            const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                                            gradient.addColorStop(0, 'rgba(253, 51, 0, 0.37)');
                                            gradient.addColorStop(1, 'rgba(253, 51, 0, 0)');
                                            return gradient;
                                        },
                                        fill: true,
                                        // backgroundColor: gradient,
                                        tension: 0.4, // Adjust tension for a smoother line
                                        // backgroundColor:gradient
                                    },
                                ],
                            }}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                layout: {
                                    padding: {
                                        left: 0,
                                        right: 0,
                                        top: 0,
                                        bottom: 0,
                                    },
                                },
                                scales: {
                                    x: {
                                        ticks: {
                                            maxRotation: 45,
                                            minRotation: 45,
                                        },
                                        grid: {
                                            display: false,
                                        },
                                    },
                                    y: {
                                        // suggestedMax: 100,
                                        // suggestedMin: 0,
                                        ticks: {
                                            stepSize: 20,
                                        },
                                    },
                                },
                                elements: {
                                    line: {
                                        tension: 0, // Disable bezier curves
                                    },
                                },
                                plugins: {
                                    legend: {
                                        display: false, // Hide the legend
                                    },
                                    tooltip: {
                                        callbacks: {
                                            label: (tooltipItem) => {
                                                if (category === "chipping_bunkers") {
                                                    return Number(tooltipItem.formattedValue.replace(/,/g, '')).toFixed(1) + "%";
                                                } else {
                                                    return Number(tooltipItem.formattedValue.replace(/,/g, '')).toFixed(1)
                                                }
                                            },
                                        },
                                    }
                                },
                            }}
                            height={200}
                        />
                    </Paper>
                    <Link href={checkScAccess() ? (categoryLinks[category] || `#link-to-${category.toLowerCase()}`) : '/scratch-club-benefits/'} target="_blank"
                          style={{
                              display: 'block',
                              textAlign: 'right',
                              marginTop: '10px',
                              color: isMobile ? '#FD3300' : '#7B726C',
                              textDecoration: 'none',
                              fontFamily: isMobile ? "'Lato', sans-serif" : "'Repro', sans-serif",
                              fontWeight: isMobile ? 600 : 400,
                              fontSize: "16px",
                          }}>
                        Improve {categoryDisplayNameMap[category] || category} <ArrowOutwardOutlinedIcon sx={{color: isMobile ? '#FD3300' : '#7B726C'}}/>
                    </Link>
                </Grid>
            );
            rows[rows.length - 1].push(rowGraph);
        });
        return rows.map((row, rowIndex) => (
            <Grid container spacing={2}
            key={rowIndex} style={{marginBottom: '20px'}} alignItems="center"
                  justifyContent="center">
                {row}
            </Grid>
        ));
    };

// render fullscreen graphs
    const renderGraph = (category: any) => {
        const chartData = {
            labels: Object.keys(categoryTotals[category] || {}).flatMap((year) => {
              return Object.keys(categoryTotals[category]?.[year] || {}).map((month) => {
                const monthName = monthNames[parseInt(month, 10)];
                return monthName ? `${monthName} ${year}` : `${month} ${year}`;
              });
            }),
            datasets: [
                {
            // shows sums
                // data: Object.keys(categoryTotals[category] || {}).flatMap((year) => {
                //     return Object.keys(categoryTotals[category]?.[year] || {}).map((month) => {
                //       return categoryTotals[category]?.[year]?.[month]?.sum || 0; // Use sum instead of average
                //     });
                // }),

            //shows averages
                data: Object.keys(categoryTotals[category] || {}).flatMap((year) => {
                    return Object.keys(categoryTotals[category]?.[year] || {}).map((month) => {
                        return categoryTotals[category]?.[year]?.[month]?.average || 0;
                    });
                    }),
                  pointRadius: 5,
                  pointBackgroundColor: '#DB2C00',
                  borderWidth: 1,
                  borderColor: '#DB2C00',
                  fill: true,
                  backgroundColor: (context: ScriptableContext<"line">) => {
                      const ctx = context.chart.ctx;
                      const gradient = ctx.createLinearGradient(0, 0, 0, 200);
                      gradient.addColorStop(0, 'rgba(253, 51, 0, 0.42)');
                      gradient.addColorStop(1, 'rgba(253, 51, 0, 0)');
                      return gradient;
                  },
                  tension: 0.4,
                },
            ],
        }

        return (
            <Grid container spacing={2} key={category}>
                <Paper variant="outlined" style={{
                    position: 'relative',
                    overflow: 'visible',
                    width: '100%',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    paddingTop: '35px'
                }}>
                    <Line data={chartData}
                          options={{
                              layout: {
                                  padding: {
                                      left: 0,
                                      right: 0,
                                      top: 0,
                                      bottom: 0,
                                  }
                              },
                              scales: {
                                  x: {
                                      ticks: {
                                          maxRotation: 45,
                                          minRotation: 45,
                                      },
                                      grid: {
                                          display: false,
                                      },
                                  },
                                  y: {
                                    //   suggestedMax: 100,
                                    //   suggestedMin: 0,
                                      ticks: {
                                          stepSize: 20,
                                      },
                                  },
                              },
                              elements: {
                                  line: {
                                      tension: 0, // Disable bezier curves
                                  },
                              },
                              plugins: {
                                  legend: {
                                      display: false, // Hide the legend
                                  },
                                  tooltip: {
                                      callbacks: {
                                          label: (tooltipItem) => {
                                            if (category === "chipping_bunkers") {
                                                return Number(tooltipItem.formattedValue.replace(/,/g, '')).toFixed(1) + "%";
                                            } else {
                                                return Number(tooltipItem.formattedValue.replace(/,/g, '')).toFixed(1)
                                            }
                                          },
                                      },
                                  }
                              },
                          }}
                    />
                </Paper>
            </Grid>
        );
    };

    interface ScoreObject {
      [year: string]: {
        [month: string]: {
          sum: number;
          count: number;
          average: number;
          averages: number[];
        };
      };
    }

    //calculate average scores
    const scoreAvgData: ScoreObject = categoryTotals['scoreAvg'];

    const newAverages: { month: string; average: number }[] = [];

    if (scoreAvgData) {
      for (const [year, months] of Object.entries(scoreAvgData)) {
        for (const [month, data] of Object.entries(months)) {
          const { average } = data; // This line should work with the correct type declaration
          newAverages.push({ month: `${monthNames[parseInt(month, 10)]} ${year}`, average });
        }
      }
    } else {
      console.error("scoreAvgData is undefined or null");
    }

    const renderAverageScoreGraph = () => {

        return (
            // <Box style={{backgroundColor: 'white', padding: '20px', width: '76.5%', margin: '0 auto'}}>
            <Grid item xs={12} // Set full width for mobile view
            md={12}  // Set 50% width for larger screens
            lg={12}  // Set 33.33% width for larger screens
            xl={12}  // Set 25% width for extra-large screens
             style={{backgroundColor: 'white', padding: '20px'}}>
                <Typography variant="h4" style={{fontFamily: "'Repro', sans-serif", fontWeight: 400, fontSize: "16px"}}>Average Score</Typography>
                <Line
                    data={{
                        labels: newAverages.map((average) => average.month),
                        datasets: [
                            {
                                label: '',
                                data: newAverages.map((average) => average.average),
                                pointRadius: 5,
                                pointBackgroundColor: '#DB2C00',
                                borderWidth: 1,
                                borderColor: '#DB2C00',
                                fill: true,
                                tension: 0.4,
                                backgroundColor: (context: ScriptableContext<"line">) => {
                                    const ctx = context.chart.ctx;
                                    const gradient = ctx.createLinearGradient(0, 300, 0, 0);
                                    gradient.addColorStop(0, 'rgba(253, 51, 0, 0.42)');
                                    gradient.addColorStop(1, 'rgba(253, 51, 0, 0)');
                                    return gradient;
                                },
                            },
                        ],
                    }}
                    options={{
                        scales: {
                            x: {
                                ticks: {
                                    maxRotation: 45,
                                    minRotation: 45,
                                },
                            },
                            y: {
                                reverse: true,
                                beginAtZero: false,
                                suggestedMin: 60,
                                suggestedMax: 100,
                                ticks: {
                                    stepSize: 10,
                                },
                            },
                        },
                        elements: {
                            point: {
                                radius: 5,
                                backgroundColor: 'rgba(75, 192, 192, 1)',
                                borderWidth: 1,
                                borderColor: 'rgba(75, 192, 192, 1)',
                            },
                            line: {
                                tension: 0,
                            },
                        },
                        plugins: {
                            legend: {
                                display: false, // Hide the legend
                            },
                            tooltip: {
                                callbacks: {
                                    label: (tooltipItem) => {
                                        return tooltipItem.formattedValue;
                                    },
                                },
                            }
                        },
                    }}
                />
            {/* </Box> */}
            </Grid>
        );
    };


    return (
        <Fragment>

            <Box style={{
                backgroundColor: '#FCFAFA',
                paddingTop: isMobile ? 20 : 40,
                paddingBottom: isMobile ? 20 : 40,
                paddingLeft: isMobile ? 30 : 15,
                paddingRight: isMobile ? 30 : 15,
            }}
                 alignItems={'center'}
                 justifyContent={'center'}
                 id={"pg-course-graphs"}
            >
                {Object.keys(categoryTotals).length !== 0 &&
                    <div style={{ width: '90%', maxWidth: '1440px', margin: '0 auto' }}>
                    {/* <div style={{width: '100%', maxWidth: '1200px', margin: '0 auto'}}> */}
                        {renderCourseGraphs()}
                        {renderAverageScoreGraph()}
                    </div>
                }
            </Box>
            <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="sm" fullWidth>
                <DialogContent>
                    {selectedCategory && renderGraph(selectedCategory)}
                </DialogContent>
            </Dialog>
        </Fragment>
    );

};
export default CourseGrid;